import { render, staticRenderFns } from "./PreviewArticle.vue?vue&type=template&id=10b64af2&scoped=true"
import script from "./PreviewArticle.vue?vue&type=script&lang=js"
export * from "./PreviewArticle.vue?vue&type=script&lang=js"
import style0 from "./PreviewArticle.vue?vue&type=style&index=0&id=10b64af2&prod&lang=scss"
import style1 from "./PreviewArticle.vue?vue&type=style&index=1&id=10b64af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b64af2",
  null
  
)

export default component.exports